// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .TagActivity {
  width: 465px;
  height: 54px;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  background-color: #efeeed;
  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5);
  border-radius: 50px;
  cursor: pointer;
}
@media (max-width: 768px) {
  .TagActivity {
    width: 380px;
  }
}
@media (max-width: 320px) {
  .TagActivity {
    width: 320px;
  }
} */

.TagActivity {
    width: 100%;
    height: 54px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    /* background-color: #efeeed;
    box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
      -6px -6px 12px rgba(255, 255, 255, 0.5); */
    background-color: white;
    border: solid 1px #dee0e1;
    border-radius: 50px;
    cursor: pointer;
    padding: 5px 10px;
  }
  
  @media screen and (min-width: 768px) {
    .TagActivity{
      width: 370px;
    }
  }
  @media screen and (min-width: 1024px) {
    .TagActivity{
      width: 480px;
    }
  }

.usable-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  
  .AskActivity_active {
    width: 100%;
    height: 625px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: #fefefe;
    border-radius: 20px;
    box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
      -6px -6px 12px rgba(255, 255, 255, 0.5);
    cursor: pointer;
    overflow: hidden;
    padding: 5px 10px;
    margin-bottom: 15px;
    margin-top: 30px;
  }
  .color-combination{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 54px;
    background-color: #fefefe;
    border-radius: 20px;
    cursor: pointer;
    padding: 5px 10px;
  }
  
  @media screen and (min-width: 768px) {
    .AskActivity_active {
      width: 375px;
      height: 625px;
      margin-top: 30px !important;
    }
  }
  
  @media screen and (min-width: 1024px) {
    .AskActivity_active {
      width: 480px;
      height: 625px;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/Modules/Activity/Activites/Tag Activity/TagActtivity.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB;;gDAE4C;IAC5C,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE;MACE,YAAY;IACd;EACF;EACA;IACE;MACE,YAAY;IACd;EACF;;AAEF;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB;6CACyC;IACzC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE;MACE,YAAY;MACZ,aAAa;MACb,2BAA2B;IAC7B;EACF;;EAEA;IACE;MACE,YAAY;MACZ,aAAa;IACf;EACF","sourcesContent":["/* .TagActivity {\r\n  width: 465px;\r\n  height: 54px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 30px;\r\n  background-color: #efeeed;\r\n  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5);\r\n  border-radius: 50px;\r\n  cursor: pointer;\r\n}\r\n@media (max-width: 768px) {\r\n  .TagActivity {\r\n    width: 380px;\r\n  }\r\n}\r\n@media (max-width: 320px) {\r\n  .TagActivity {\r\n    width: 320px;\r\n  }\r\n} */\r\n\r\n.TagActivity {\r\n    width: 100%;\r\n    height: 54px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-top: 30px;\r\n    /* background-color: #efeeed;\r\n    box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n      -6px -6px 12px rgba(255, 255, 255, 0.5); */\r\n    background-color: white;\r\n    border: solid 1px #dee0e1;\r\n    border-radius: 50px;\r\n    cursor: pointer;\r\n    padding: 5px 10px;\r\n  }\r\n  \r\n  @media screen and (min-width: 768px) {\r\n    .TagActivity{\r\n      width: 370px;\r\n    }\r\n  }\r\n  @media screen and (min-width: 1024px) {\r\n    .TagActivity{\r\n      width: 480px;\r\n    }\r\n  }\r\n\r\n.usable-container{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  .AskActivity_active {\r\n    width: 100%;\r\n    height: 625px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    background-color: #fefefe;\r\n    border-radius: 20px;\r\n    box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n      -6px -6px 12px rgba(255, 255, 255, 0.5);\r\n    cursor: pointer;\r\n    overflow: hidden;\r\n    padding: 5px 10px;\r\n    margin-bottom: 15px;\r\n    margin-top: 30px;\r\n  }\r\n  .color-combination{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 54px;\r\n    background-color: #fefefe;\r\n    border-radius: 20px;\r\n    cursor: pointer;\r\n    padding: 5px 10px;\r\n  }\r\n  \r\n  @media screen and (min-width: 768px) {\r\n    .AskActivity_active {\r\n      width: 375px;\r\n      height: 625px;\r\n      margin-top: 30px !important;\r\n    }\r\n  }\r\n  \r\n  @media screen and (min-width: 1024px) {\r\n    .AskActivity_active {\r\n      width: 480px;\r\n      height: 625px;\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
